import { Box, Grid } from '@mui/material';
import WatchLaterIcon from '@mui/icons-material/WatchLater';

import BaggageInfo from '@FlightsComponents/BaggageInfo';
import Salida from '@shared/assets/logos/salida';
import FlightItineraryHeader from '@shared/pages/Flights/components/FlightItinerary/FlightItineraryHeader';

import FlightSegmentSuccess from './FlightSegmentSuccess';
import HorizontalSeparator from '@FlightsComponents/HorizontalSeparator';
import FlightItineraryLine from './FlightItineraryLine';
import ItineraryText from '@FlightsComponents/ItineraryText';

// duración
const flightTimeConvert = minutesTotal => {
  if (minutesTotal == null) return '';
  const hours = Math.floor(minutesTotal / 60);
  const minutes = minutesTotal % 60;

  if (!hours) return `${minutes} minutos`;
  if (!minutes) return `${hours} hora${hours > 1 ? 's' : ''}`;

  const formattedMinutes = String(minutes).padStart(2, '0');
  return `${hours}:${formattedMinutes} horas`;
};

const Separator = ({ id }) => (
  <HorizontalSeparator id={id} color="#E5E5E5" isSuccess />
);

const FlightSegmentListSuccess = ({ firstAirport, lastAirport, option }) => (
  <>
    <FlightSegmentSuccess
      icon={<Salida />}
      date={option.departure}
      time={option.departure}
      origin={option.origin_city}
      airport={firstAirport[1] || firstAirport[0]}
    />
    <FlightSegmentSuccess
      icon={<Salida />}
      date={option.arrival}
      time={option.arrival}
      origin={option.destination_city}
      airport={lastAirport[1] || lastAirport[0]}
    />
  </>
);

const FlightDuration = ({ duration }) => (
  <Box display="flex" alignItems="center" justifyContent="start">
    <WatchLaterIcon fontSize="small" />
    <ItineraryText sx={{ ml: 1, fontWeight: 600 }}>
      Duración {flightTimeConvert(duration)}
    </ItineraryText>
  </Box>
);

const FlightItineraryBlockSuccess = ({
  option,
  firstFlight,
  firstAirport,
  lastAirport,
  cluster,
  index,
}) => {
  return (
    <Grid container sx={{ pt: 2 }}>
      {/* LEFT CONTENT */}
      <Grid item xs={12} md={10} sx={{ textAlign: 'center' }}>
        <FlightItineraryHeader
          option={option}
          cluster={cluster}
          leg={cluster.legs[index]}
          withEquipment
          firstFlight={firstFlight}
        />

        <Separator id={`SEPARATORSUP-${index}`} />

        <FlightItineraryLine option={option} />

        <FlightSegmentListSuccess
          firstAirport={firstAirport}
          lastAirport={lastAirport}
          option={option}
        />

        <Separator id={`SEPARATORINF-${index}`} />

        <FlightDuration duration={option.flight_time} />
      </Grid>

      {/* RIGHT SIDE (BAGGAGE) */}
      <Grid
        item
        xs={12}
        md={2}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <BaggageInfo baggage={option.flight_baggage} />
      </Grid>
    </Grid>
  );
};

export default FlightItineraryBlockSuccess;
